// extracted by mini-css-extract-plugin
export var inputContainer = "_og-0";